export const BASE_CLASS = 'mt-Detail--new'
